import api from '@/api/api.coffee'
export default
  # Restaurant
  restaurant: (state) ->
    return '' if !state.restaurant
    state.restaurant
  ip: (state) ->
    return '' if !state.ip
    state.ip
  subdomain: (state) ->
    return '' if !state.subdomain
    state.subdomain
  tableNo: (state) ->
    return '' if !state.tableNo
    state.tableNo
  lang: (state) ->
    return '' if !state.lang
    state.lang
  restaurantIconBanner: (state) ->
    false
  restaurantIconHeader: (state) ->
    true
  restaurantIconUrl: (state) ->
    return '' if !state.restaurant.stylesheet
    return '' if !state.restaurant.stylesheet.iconUrl
    if Number(state.restaurant.stylesheet.iconUrl.indexOf 'http') == -1
      state.restaurant.stylesheet.iconUrl = 'https://api.onlineordersnow.com'+state.restaurant.stylesheet.iconUrl
    state.restaurant.stylesheet.iconUrl
  restaurantHeaderUrl: (state) ->
    return '' if !state.restaurant.stylesheet
    return '' if !state.restaurant.stylesheet.headerUrl
    if Number(state.restaurant.stylesheet.headerUrl.indexOf 'http') == -1
      state.restaurant.stylesheet.headerUrl = 'https://api.onlineordersnow.com'+state.restaurant.stylesheet.headerUrl
    state.restaurant.stylesheet.headerUrl
  restaurantBrand: (state) ->
    return '' if !state.restaurant
    return '' if !state.restaurant.brand
    state.restaurant.brand
  restaurantId: (state) ->
    return '' if !state.restaurant
    return '' if !state.restaurant.uniqueId
    state.restaurant.uniqueId
  restaurantBrandHeader: ->
    true
  restaurantBrandMenuDrawer: ->
    false
  #User
  user: (state) ->
    return {} if !state.user
    state.user
  phone: (state) ->
    return '' if !state.mobile
    state.mobile
  # Toggle
  toggleOpen:(state) ->
    return 'Open Menu' if !state.toggleOpen
    state.toggleOpen
  toggleClose:(state) ->
    return 'Close Menu' if !state.toggleClose
    state.toggleClose
  # Order
  orderHeader: (state) ->
    return 'Your Order' if !state.orderHeader
    state.orderHeader
  orderMessage: (state) ->
    return 'Please add some items to your order.' if !state.orderMessage
    state.orderMessage
  discount: (state) ->
    return 'Discount' if !state.discount
    state.discount
  subtotal: (state) ->
    return 'Subtotal' if !state.subtotal
    state.subtotal
  order: (state) ->
    return '' if !state.order
    state.order
  orderDetails: (state) ->
    return '' if !state.order
    state.order
  orderItemSum: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderItemSum
    state.order.orderItemSum
  orderItemTotal: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderItemTotal
    state.order.orderItemTotal
  orderSubTotal: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderSubTotal
    state.order.orderSubTotal
  orderTotal: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderTotal
    state.order.orderTotal
  orderPaid: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderPaid
    state.order.orderPaid
  orderDue: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderDue
    state.order.orderDue
  editFlag: (state) ->
    return '' if !state.order
    state.order.itemDetails.editFlag
  orderTip: (state) ->
    return 0 if !state.order
    return 0 if !state.order.tip
    state.order.tip
  orderComment: (state) ->
    return '' if !state.order
    return '' if !state.order.comment
    state.order.comment
  customerEmail: (state) ->
    return 0 if !state.order
    return 0 if !state.order.email
    state.order.email
  orderDiscount: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderDiscount
    state.order.orderDiscount
  deliveryFee: (state) ->
    return 0 if !state.order
    return 0 if !state.order.deliveryFee
    state.order.deliveryFee
  orderTaxAmount: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderTaxAmount
    state.order.orderTaxAmount
  orderFeeAmount: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderFeeAmount
    state.order.orderFeeAmount
  orderTaxAndFee: (state) ->
    return 0 if !state.order
    state.order.orderTaxAndFee
  orderTaxList: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderTaxes
    state.order.orderTaxes
  orderFeeList: (state) ->
    return 0 if !state.order
    return 0 if !state.order.orderFees
    state.order.orderFees
  orderItemsLength: (state) ->
    return 0 if !state.order
    return 0 if !state.order.items
    state.order.items.length
  orderItemDetailsLength: (state) ->
    return 0 if !state.order
    return 0 if !state.order.itemDetails
    state.order.itemDetails.length
  orderItems: (state) ->
    return '' if !state.order.items
    state.order.items
  orderItemDetails: (state) ->
    return [] if !state.order.itemDetails
    state.order.itemDetails
  orderEditDetails: (state) ->
    return [] if !state.order
    state.order.editDetails
  orderUpdated: (state) ->
    return false if !state.order.updated
    state.order.updated
  orderMenu: (state) ->
    return [] if !state.orderMenu
    state.orderMenu
  orderMenuDetails: (state) ->
    return [] if !state.orderMenuDetails
    state.orderMenuDetails
  orderMenuDetailsLoaded: (state) ->
    return false if !state.orderMenuDetails
    state.orderMenuDetails.length > 0
  # coupons
  coupons: (state) ->
    return [] if !state.coupons
    state.coupons
  couponItemIds: (state) ->
    return {} if !state.coupons
    return {} if !state.coupons.itemIds
    state.coupons.itemIds
  mywayIds: (state) ->
    return {} if !state.myway
    return {} if !state.myway.itemIds
    state.myway.itemIds
  # Header
  headerOrderTitle: (state) ->
    return "Cart" if !state.headerOrderTitle
    state.headerOrderTitle
  headerOrderIcon: (state) ->
    return "fa-shopping-cart"
  headerCheckoutTitle: (state) ->
    return "Checkout" if !state.headerCheckoutTitle
    state.headerCheckoutTitle
  headerCheckoutIcon: (state) ->
    return "fa-check-circle"
  headerCouponTitle: (state) ->
    return "Coupons" if !state.headerCouponTitle
    state.headerCouponTitle
  headerFaqTitle: (state) ->
    return "FAQs" if !state.headerFaqTitle
    state.headerFaqTitle
  headerCouponIcon: (state) ->
    return "fa-tags"
  headerFeaturesTitle: (state) ->
    return "Popular" if !state.headerFeaturesTitle
    state.headerFeaturesTitle
  forgetLabel: (state) ->
    return "Don't Forget" if !state.forgetLabel
    state.forgetLabel
  headerFeaturesIcon: (state) ->
    return "fa-award"
  headerMywayTitle: (state) ->
    return "My Way" if !state.headerMywayTitle
    state.headerMywayTitle
  headerMywayIcon: (state) ->
    return "fa-award"
  buttonCheckoutLabel: (state) ->
    return "Checkout" if !state.buttonCheckoutLabel
    state.buttonCheckoutLabel
  buttonMenuLabel: (state) ->
    return "Menu" if !state.buttonMenuLabel
    state.buttonMenuLabel
  okLabel: (state) ->
    return "Ok" if !state.okLabel
    state.okLabel
  categoryPanels: (state) ->
    return {} if !state.panels
    return {} if !state.panels.category
    state.panels.category
  pizzaPanels: (state) ->
    return {} if !state.panels
    return {} if !state.panels.pizza
    state.panels.pizza
  typePanels: (state) ->
    return {} if !state.panels
    return {} if !state.panels.pizzaType
    state.panels.pizzaType
  menuItemGroupPanels: (state) ->
    return {} if !state.panels
    return {} if !state.panels.menuitemgroup
    state.panels.menuitemgroup
  # Drawers
  menuDrawer: (state) ->
    return false if !state.drawers
    return false if !state.drawers.menu
    state.drawers.menu
  menuDrawerLinks: (state) ->
    out = []
    if state.restaurant
      if state.restaurant.stylesheet
        if state.restaurant.stylesheet.mainWebsite
          out.push { "title": "Website", "href": state.restaurant.stylesheet.mainWebsite, "target": "_blank", "icon": "fa-external-link" }
        if state.restaurant.stylesheet.facebook
          out.push { "title": "Facebook", "href": state.restaurant.stylesheet.facebook, "target": "_blank", "icon": "fa-facebook" }
        if state.restaurant.stylesheet.twitter
          out.push { "title": "Twitter", "href": state.restaurant.stylesheet.twitter, "target": "_blank", "icon": "fa-twitter" }
    return false if !state.restaurant
    out
  menuDrawerRestartLabel: (state) ->
    return "Start Over" if !state.menuDrawerRestartLabel
    state.menuDrawerRestartLabel
  faqMessage: (state) ->
    return "Start Over" if !state.faqMessage
    state.faqMessage
  couponDrawer: (state) ->
    return false if !state.drawers
    return false if !state.drawers.coupon
    state.drawers.coupon
  orderDrawer: (state) ->
    return false if !state.drawers
    return false if !state.drawers.order
    state.drawers.order
  features: (state) ->
    return [] if !state.features.list
    state.features.list
  featuresDrawer: (state) ->
    return false if !state.drawers
    return false if !state.drawers.features
    state.drawers.features
  recommends: (state) ->
    return [] if !state.recommendations.list
    state.recommendations.list
  myway: (state) ->
    return [] if !state.myway.list
    state.myway.list
  mywayDrawer: (state) ->
    return false if !state.drawers
    return false if !state.drawers.myway
    state.drawers.myway

  # Display
  styleSheet: (state) ->
    return '' if !state.restaurant
    return '' if !state.restaurant.stylesheet
    return '' if !state.restaurant.stylesheet.css
    state.restaurant.stylesheet.css
  privacyPolicy: (state) ->
    return '' if !state.restaurant
    return '' if !state.restaurant.privacyPolicy
    state.restaurant.privacyPolicy
  refundPolicy: (state) ->
    return '' if !state.restaurant
    return '' if !state.restaurant.refundPolicy
    state.restaurant.refundPolicy
  securityStatement: (state) ->
    return '' if !state.restaurant
    return '' if !state.restaurant.securityStatement
    state.restaurant.securityStatement
  dialogWidth: (state) ->
    return '100%' if !state.dialogWidth
    state.dialogWidth
  pizzaExtras: (state) ->
    return '' if !state.pizzaExtras
    state.pizzaExtras
  addonExtras: (state) ->
    return '' if !state.addonExtras
    state.addonExtras
  itemTotal: (state) ->
    return '' if !state.itemTotal
    state.itemTotal
  pizzaCount: (state) ->
    return '' if !state.pizzaCount
    state.pizzaCount
  screenWide: (state) ->
    return '' if !state.screenWidth
    state.screenWidth
  lang: (state) ->
    return '' if !state.lang
    state.lang
  menuOverflowHidden: (state) ->
    return false if !state.menu
    state.menu.overflowHidden
  tipLevels: (state) ->
    return [] if !state.tipLevels
    state.tipLevels
  location: (state) ->
    return {} if !state.location
    state.location
  updateLocation: (state) ->
    return {} if !state.location
    state.location
  updateDescFlag: (state) ->
    return {} if !state.descFlag
    state.descFlag
  updateMenuFlag: (state) ->
    return {} if !state.menuFlag
    state.menuFlag
  expiration: (state) ->
    return 0 if !state.stateTime
    return 0 if !state.stateTime.expiration
    state.stateTime.expiration
  warning: (state) ->
    return 0 if !state.stateTime
    return 0 if !state.stateTime.warning
    state.stateTime.warning
  takeoutLocations: (state) ->
    return [] if !state.restaurant
    return [] if !state.restaurant.takeoutLocations
    tmp = []
    for location, locationIndex in state.restaurant.takeoutLocations
      tmp.push location.location
    tmp
  deliveryLocations: (state) ->
    return [] if !state.restaurant
    return [] if !state.restaurant.deliveryLocations
    tmp = []
    for location, locationIndex in state.restaurant.takeoutLocations
      tmp.push location.location
    tmp
  locations: (state) ->
    return [] if !state.restaurant
    return [] if !state.restaurant.locations
    tmp = []
    for location, locationIndex in state.restaurant.locations
      tmp.push location
    tmp
  closedLocations: (state) ->
    return [] if !state.restaurant
    return [] if !state.restaurant.closedLocations
    tmp = []
    for location, locationIndex in state.restaurant.closedLocations
      tmp.push location
    tmp
  map: (state) ->
    return undefined if !state.map
    state.map
  error: (state) ->
    return '' if !state.error
    state.error
  errorTitle: (state) ->
    return '' if !state.errorTitle
    state.errorTitle
  baseURL: (state) ->
    return '' if !state.baseURL
    state.baseURL
  updatePath: (state) ->
    return '' if !state.path
    state.path
  clickFlag: (state) ->
    return '' if !state.clickFlag
    state.clickFlag
